<template>
  <!--切换账户 列表 组件-->
  <div
    v-if="ywtAccountChoose ? accountList.length > 0 :totalAccountList.length > 0"
    class="change-account"
  >
    <!--    这里搜索好像用不起，直接写死，以防万一-->
    <div class="search-profile" v-if="showSearch && false">
      <el-input v-model="searchText" size="mini" width="100%">
        <i slot="prefix" class="el-icon-search"></i>
      </el-input>
    </div>
    <div class="wrap" :style="{ paddingTop: showSearch ? lineHeight + 10 + 'px' : '0' }">
      <!--加入企业的账号列表-->
      <ul>
        <template>
          <li
            v-for="(user, index) in accountList"
            v-show="user"
            :title="user.corpName || user.name"
            :style="{ height: lineHeight + 'px' }"
            :class="
              !user.corpUserId ? 'active' : ''
            "
            @click="changeAccount(user)"
            :key="index"
          >
            <div class="d-box">
              <template v-if="personOrEnt(user)">
                <span class="sn">我自己</span>
              </template>
              <span class="sn joined" v-else>加入的</span>
              <img
                style="width: 20px; height: 20px; margin-right: 0"
                v-if="user.userStemFrom === -16 && !isInDingTalk"
                src="/images/icon/dingIcon.png"
                alt
              />
              <template v-if="user.systemType === 'ywt'">
                <img style="max-height: 28px" src="../../static/images/ywt_logo.png" alt />
                <span>（{{(user.corpName || user.name).substring(0, 5)}}）</span>
              </template>
              <span v-else>{{ user.corpName || user.name }}</span>
            </div>
            <span v-show="!user.corpUserId" class="current-user">
              <img src="../../static/images/console/seleted.png" alt class="el-icon-check" />
            </span>
          </li>
        </template>
      </ul>
    </div>
  </div>
</template>

<script>
import {
  loginOrRefresh,
  setCurrentUser
} from "@/assets/js/http-serve/corp/common";
import { fileOperShow } from "@/assets/js/http-serve/http-methods";
import { isInDingTalk } from "../../assets/js/utils/ding-env";

export default {
  name: "index",
  props: {
    lineHeight: {
      type: Number
    },
    users: {
      type: Array
    },
    // 1794 是否是需要选择业务通账号的切换 .默认不是
    ywtAccountChoose: {
      type: Boolean,
      default: false,
    }
  },
  data () {
    return {
      isInDingTalk,
      searchText: "",
      accountList: [],
      fileOperShow: fileOperShow
    };
  },
  computed: {
    authUser () {
      return this.$store.getters.authUser || {};
    },
    showSearch () {
      return this.totalAccountList.length > 5;
    },
    totalAccountList () {
      let arr = [];
      // 企业账户加这个干啥，这个企业加了自己，当没成员时，以前也是不展示的
      // let mine = this.$store.getters.allAuthUser.accountInfoVO;
      // if (mine.userType == 1) arr.push(mine);
      arr = arr.concat(this.$store.getters.allAuthUser.bindCorpUsers);
      if (arr.length > 0) {
        this.$emit("showExpandIcon");
      }
      return arr;
    }
  },
  mounted () {
    this.initAccountList();
  },
  methods: {
    initAccountList () {
      this.accountList = [];
      if (this.totalAccountList) {
        this.totalAccountList.forEach(user => {
          this.accountList.push(user);
        });
      }
      if (isInDingTalk) {
        this.accountList = this.accountList.filter(item => {
          item.userStemFrom == -16;
        });
      }
      this.accountList.push(this.$store.getters.authUser)
      //有ywt账户选择的时候 1794
      if (this.ywtAccountChoose && !isInDingTalk) {
        this.accountList = this.accountList.flatMap((item) => {
          return (item.corpIsMerchant === 1 || item.merchantFlag === 1) && item.ywtIsBind ? [item, { systemName: '业务定制系统', systemType: 'ywt', ...item }] : item;
        })
      }
    },
    // 切换用户时，也要清空搜索文字
    changeAccount (user) { //这个页面一定是在个人用户的控制台的，（目前看来是这样）
      if (user.systemType === 'ywt') { //个人用户跳ywt，肯定会切换身份
        setCurrentUser(user).finally(
          () => {
            this.$router.push({
              path: '/ywtSystem',
              query: {
                ...this.$route.query,
                ywtLayoutStyle: 2,
                work: 2,
              },
            });
          }
        );
      } else if (!user.corpUserId) { //不是业务通就照旧逻辑走
        return false;
      } else if (this.personOrEnt(user) && user.userStemFrom !== -16) {
        this.searchText = "";
        setCurrentUser(this.$store.getters.allAuthUser.manCorpUser).finally(
          () => {
            this.$router.push({
              path: "/console/member",
            });
          }
        );
      } else if (!(user.perms && user.perms.length > 0)) {
        return this.$message.error("暂无权限，请联系管理员开通。");
      } else {
        this.searchText = "";
        setCurrentUser(user).finally(() => {
          this.$router.push({
            path: "/console/member",
          });
        });
      }
    },
    // 搜索账户列表
    doFilter (val) {
      try {
        if (val) {
          this.accountList = [];
          // 循环搜索加入企业的账户
          console.log(this.totalAccountList);
          this.totalAccountList.forEach(user => {
            if (user.corpName) {
              if (user.corpName.indexOf(val) != -1) {
                this.accountList.push(user);
              }
            } else {
              if (user.name.indexOf(val) != -1) {
                this.accountList.push(user);
              }
            }
          });
        } else {
          // 初始化账户列表
          this.initAccountList();
        }
      } catch (e) {
        console.log(e);
      }
    },
    // 是否是企业或者个人账户
    personOrEnt (user) {
      let name = user.corpName || user.name;
      return (
        this.$store.getters.allAuthUser &&
        this.$store.getters.allAuthUser.accountInfoVO.name === name
      );
    },
    getTitle (user) {
      let isPersonOrEntBool = this.personOrEnt(user);
      let name = user.corpName || user.name;
      let accountName = this.$store.getters.allAuthUser
        ? this.$store.getters.allAuthUser.accountInfoVO.name
        : "";
      return isPersonOrEntBool ? name : name + "-" + accountName;
    }
  },
  watch: {
    // 检测全部用户是否更新，调用initAccountList函数初始化用户列表
    "$store.getters.allAuthUser": {
      handler (val) {
        this.initAccountList();
      },
      deep: true
    },
    searchText: {
      handler (val) {
        this.doFilter(val);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.change-account {
  position: relative;
  .search-profile {
    position: absolute;
    padding-right: 20px;
    z-index: 1;
    top: 0;
    left: 0;
    width: 100%;
    .el-input {
      width: 100%;
    }
  }
  .wrap {
    position: relative;
  }
  li {
    box-sizing: border-box;
    padding: 11px 20px 11px 10px;
    position: relative;
    white-space: nowrap;
    overflow-x: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
    font-size: 14px;
    overflow-y: hidden;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    /*transition: all 0.5s;*/
    img {
      height: 30px;
      margin-right: 10px;
    }
    &:hover {
      background: #f9f6f6;
      .joined {
        width: 46px;
      }
    }
    .current-user {
      width: 35px;
      height: 30px;
      position: absolute;
      right: 0 !important;
      top: 0;

      img {
        vertical-align: top;
        width: 35px;
        height: 30px;
        margin: 0 !important;
      }
    }
  }
  .photo {
    max-width: 30px;
    max-height: 30px;
    border-radius: 50%;
    border: solid 1px #c5c5c5;
  }
  .isPersonOrEnt {
    display: inline-block;
    font-size: 12px;
    color: #9d8d8d;
    background: #e4e2e2;
    border-radius: 30px;
    padding: 2px 8px;
    line-height: initial;
  }
  .d-box {
    text-align: left;
    line-height: initial;
    flex: none;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    /*max-width: 170px;*/
    /*max-width: 90%;*/
    width: 100%;
  }
}
.active {
  color: #ec1c1c;
  background: #eeeeee;
  .sn {
    background: #fef3f3;
  }
  .joined {
    /*display: block;*/
    width: 46px;
  }
}
.sn {
  text-align: center;
  font-size: 12px;
  background: #eeeeee;
  border-radius: 19px;
  box-sizing: border-box;
  transition: all ease-in 0.15s;
  display: inline-block;
  width: 46px;
  height: 20px;
  line-height: 20px;
  margin-right: 5px;
  vertical-align: text-bottom;
  overflow: hidden;
}
.joined {
  width: 0;
}
</style>



// WEBPACK FOOTER //
// components/change-account/user-change.vue